/**
 * Caption for the sidebar brand tile. The admin portal is not scoped to a
 * company, so the tile names the product and the line under it names the
 * signed-in user. ("Lumiere" was the design system's codename, never the
 * product's — it should not appear in the UI.)
 *
 * Lives in its own dependency-free module so the e2e header test can assert
 * against this value instead of a copy of the string.
 */
export const PORTAL_BRAND = "Verati Admin";
